export enum HsRaycastGeometryType {
  ColorMesh,
  TexturedMesh,
  Points,
  Sprite,
}
